module.exports = __webpack_public_path__ + "static/media/doctor.c9978064.svg";